import { Environment } from 'models/environment';
import { NetworkPolicy, Policy } from 'policies/domain/policy';
import { apiRequest, EmbedAuth, getApiHost, getBasePathname } from 'shared/api';

interface Params {
  organizationId: string;
  environment: Environment;
  auth: EmbedAuth;
  policyId: string;
  alterationPackageId: string;
}

export const applyAlterationPackageToPolicy = async (params: Params) => {
  const { auth, environment, organizationId, alterationPackageId, policyId } = params;

  const basePathName = getBasePathname({
    organizationId,
    auth,
    clientAppAuth: true,
  });
  const response = await apiRequest({
    url: `${getApiHost({
      environment,
    })}${basePathName}/policies/${policyId}/alteration-packages/${alterationPackageId}/apply`,
    method: 'post',
    auth,
  });

  const networkPolicy: NetworkPolicy = await response.json();
  const policy = Policy.fromNetwork(networkPolicy);

  return policy;
};
